import type { HTMLAttributes } from 'react'

// Card — generic panel for forms and content sections. Padding is
// included so callers don't have to remember to add it.
export function Card({ className = '', ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...rest}
      className={`rounded-xl border border-line bg-surface p-4 sm:p-6 ${className}`}
    />
  )
}
